<div class="info-page">
  <header class="info-hero">
    <p class="info-kicker">Fair resolution</p>
    <h1 class="info-heading">Resolution and Dispute Policy</h1>
    <p class="info-sub">How hosts, winners, and LootLucky work through issues before they become legal disputes.</p>
  </header>

  <div class="info-grid info-grid--two">
    <article class="info-card">
      <p class="info-updated">Last updated: September 18, 2026</p>
      <h2 class="info-block-title"><span class="info-icon info-icon--gold">1</span> Overview</h2>
      <p>This policy explains how to raise and resolve disagreements related to webinars, prizes, payments, shipping, or use of LootLucky.com. It supplements our <a routerLink="/TermConditions">Terms &amp; Conditions</a>, <a routerLink="/PaymentPolicy">Payment Policy</a>, and <a routerLink="/ShippingPolicy">Shipping Policy</a>.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--teal">2</span> Contact us first</h2>
      <p>Before filing a chargeback, lawsuit, or other formal claim, you agree to contact LootLucky through the <a routerLink="/Contact">Contact</a> page and give us a reasonable chance to investigate. Include your account email, webinar or order details, and a clear description of the issue.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--wine">3</span> Informal resolution</h2>
      <p>We may facilitate communication between a host and a winner. Hosts should respond in good faith. For a free-win item that arrives damaged, hosts should begin working with the winner within 48 hours and may take up to 30 days to reach a final decision, consistent with our Terms.</p>
      <p>LootLucky is a platform. We are not the seller of host-listed prizes unless we expressly say so, and we are not a party to every dispute between a host and a winner.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--purple">4</span> Platform review</h2>
      <p>We may review records, including chat, payments, tracking, and listing details. We may pause payouts, reverse transactions, suspend accounts, or take other steps we reasonably believe are needed to enforce our policies or applicable law. Our internal review is not a legal arbitration unless we later agree to that in writing.</p>
    </article>

    <article class="info-card info-card--alert">
      <h2 class="info-block-title"><span class="info-icon info-icon--coral">5</span> Formal disputes</h2>
      <p>If the issue is not resolved informally, disputes are governed by the laws of Texas, USA, and must be brought in the courts of Texas, USA, as stated in our Terms &amp; Conditions. You waive claims that those courts are an inconvenient forum to the extent allowed by law.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--olive">6</span> Changes and contact</h2>
      <p>We may update this policy from time to time. If this policy conflicts with the Terms &amp; Conditions, the Terms control.</p>
      <a class="info-cta" routerLink="/Contact">Start a dispute request</a>
    </article>
  </div>
</div>
